/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class KubernetesAgentPreSignedUrlRequest {
    getFixupPrototypeFunction() { return KubernetesAgentPreSignedUrlRequest.fixupPrototype; }

    static newInstance(model: Partial<KubernetesAgentPreSignedUrlRequest>): KubernetesAgentPreSignedUrlRequest {
        let obj = Object.assign(new KubernetesAgentPreSignedUrlRequest(), model);
        KubernetesAgentPreSignedUrlRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<KubernetesAgentPreSignedUrlRequest>): KubernetesAgentPreSignedUrlRequest {
        if (!model) return null;
        return KubernetesAgentPreSignedUrlRequest.newInstance(<KubernetesAgentPreSignedUrlRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: KubernetesAgentPreSignedUrlRequest) {
        if (!obj) return;

        models.KubernetesAgentPreSignedUrlRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: KubernetesAgentPreSignedUrlRequest): boolean {
        Object.setPrototypeOf(obj, KubernetesAgentPreSignedUrlRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.file_data) {
            for (let val of this.file_data) {
                models.FileDetails.fixupPrototype(val);
            }
        }
    }

    file_data: Array<models.FileDetails>;

}
